var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25476 15.745C7.42777 18.918 12.5722 18.918 15.7452 15.745C18.9183 12.572 18.9183 7.42753 15.7452 4.25452C12.5722 1.08151 7.42777 1.08151 4.25476 4.25452C1.08175 7.42753 1.08175 12.572 4.25476 15.745Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79029 12.2097C9.01068 13.4301 10.9893 13.4301 12.2097 12.2097C13.4301 10.9893 13.4301 9.01066 12.2097 7.79028C10.9893 6.56989 9.01068 6.56989 7.79029 7.79028C6.5699 9.01066 6.5699 10.9893 7.79029 12.2097Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96165 9.17121L3.09466 5.74616M14.2537 3.09451L10.8286 6.9615L14.2537 3.09451ZM13.0383 9.17121L16.9053 5.74616L13.0383 9.17121ZM3.09466 14.2535L6.96165 10.8285L3.09466 14.2535ZM9.17136 13.0382L5.74631 16.9052L9.17136 13.0382ZM16.9053 14.2535L13.0383 10.8285L16.9053 14.2535ZM10.8286 13.0382L14.2537 16.9052L10.8286 13.0382ZM5.74631 3.09451L9.17136 6.9615L5.74631 3.09451Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.18bf17ccb9d641da9f0af045e7b26c0f.svg";
export { ForwardRef as ReactComponent };